<template>
  <div>
    <h2 style="margin-bottom: 16px;">信息编辑</h2>
    <el-tabs type="border-card">
      <!-- 个人信息 -->
      <el-tab-pane label="个人信息编辑">
        <el-form label-width="150px" style="max-width: 620px;">
          <el-form-item label="头像">
            <el-upload
              action="#"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              @change="avatarChange"
            >
              <img v-if="form.avatar" :src="form.avatar" style="width: 120px; height: 120px; border-radius: 6px; display: block;" />
              <i v-else class="el-icon-plus" style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; font-size: 28px; color: #8c939d;"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="昵称"><el-input v-model="form.nickname"></el-input></el-form-item>
          <el-form-item label="邮箱"><el-input v-model="form.mail"></el-input></el-form-item>
          <el-form-item label="qq"><el-input v-model="form.qq"></el-input></el-form-item>
          <el-form-item label="电话"><el-input v-model="form.phone"></el-input></el-form-item>
          <el-form-item label="个人简介">
            <el-input type="textarea" v-model="form.synopsis" :rows="4"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 实名认证 -->
      <el-tab-pane label="实名认证">
        <el-steps :active="form.realstate" align-center style="margin-bottom: 24px; max-width: 620px;">
          <el-step title="填写个人信息"></el-step>
          <el-step title="审核中"></el-step>
          <el-step title="认证通过"></el-step>
        </el-steps>
        <el-form label-width="150px" style="max-width: 620px;">
          <el-form-item label="姓名">
            <el-input v-model="student.realname" :disabled="disabled(realstateNum)"></el-input>
          </el-form-item>
          <el-form-item label="学号">
            <el-input v-model="student.studentid" :disabled="disabled(realstateNum)"></el-input>
          </el-form-item>
          <el-form-item label="学生证">
            <el-upload
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="(f, l) => fileListChange(f, l, 'student')"
              :file-list="student.filelist"
              :disabled="disabled(realstateNum)"
              :limit="3"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="disabled(realstateNum)" @click="onSubmitstudent">确定</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 公司认证 -->
      <el-tab-pane label="公司认证">
        <el-steps :active="companystateNum" align-center style="margin-bottom: 24px; max-width: 620px;">
          <el-step title="填写公司信息"></el-step>
          <el-step title="等待审核"></el-step>
          <el-step title="认证通过"></el-step>
        </el-steps>
        <el-form label-width="150px" style="max-width: 620px;">
          <el-form-item label="公司名称">
            <el-input v-model="company.companyname" :disabled="disabled(companystateNum)"></el-input>
          </el-form-item>
          <el-form-item label="公司信息">
            <el-upload
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="(f, l) => fileListChange(f, l, 'company')"
              :file-list="company.filelist"
              :disabled="disabled(companystateNum)"
              :limit="3"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="disabled(companystateNum)" @click="onSubmitcompany">确定</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getUser, updateUser } from '@/api'

export default {
  name: 'Myself',
  data() {
    return {
      form: { avatar: '', nickname: '', mail: '', qq: '', phone: '', synopsis: '' },
      realstateNum: 1,
      companystateNum: 1,
      student: { m: 'student', realname: '', studentid: '', studentcard: [], filelist: [] },
      company: { m: 'company', companyname: '', companyimg: [], filelist: [] }
    }
  },
  methods: {
    disabled(state) {
      return state === 2 || state === 3
    },
    beforeAvatarUpload(file) {
      this.form.avatar = URL.createObjectURL(file)
      return false
    },
    avatarChange() {},
    fileListChange(file, fileList, type) {
      if (type === 'student') {
        this.student.filelist = fileList
        this.student.studentcard = fileList.filter((f) => f.raw).map((f) => URL.createObjectURL(f.raw))
      } else {
        this.company.filelist = fileList
        this.company.companyimg = fileList.filter((f) => f.raw).map((f) => URL.createObjectURL(f.raw))
      }
    },
    onSubmit() {
      updateUser({ ...this.form, m: 'user' }).then((res) => {
        if (res.state.type === 'SUCCESS') {
          this.$message.success('保存成功')
          this.$store.dispatch('user/setUserInfo', res.data.userinfo)
        }
      })
    },
    onSubmitstudent() {
      if (!this.student.realname || !this.student.studentid) {
        this.$message.error('请填写姓名和学号')
        return
      }
      updateUser({ ...this.student, studentcard: JSON.stringify(this.student.studentcard) }).then((res) => {
        if (res.state.type === 'SUCCESS') {
          this.$message.success('信息提交成功等待审核')
          this.getuser()
        }
      })
    },
    onSubmitcompany() {
      if (!this.company.companyname) {
        this.$message.error('请填写公司名称')
        return
      }
      updateUser({ ...this.company, companyimg: JSON.stringify(this.company.companyimg) }).then((res) => {
        if (res.state.type === 'SUCCESS') {
          this.$message.success('信息提交成功等待审核')
          this.getuser()
        }
      })
    },
    getuser() {
      getUser().then((res) => {
        const d = res.data || {}
        this.form = { avatar: d.avatar, nickname: d.nickname, mail: d.mail, qq: d.qq, phone: d.phone, synopsis: d.synopsis }
        this.realstateNum = Number(d.realstate) || 1
        this.companystateNum = Number(d.companystate) || 1
        this.student = {
          m: 'student', realname: d.realname || '', studentid: d.studentid || '',
          studentcard: JSON.parse(d.studentcard || '[]'), filelist: (JSON.parse(d.studentcard || '[]')).map((u) => ({ url: u }))
        }
        this.company = {
          m: 'company', companyname: d.companyname || '',
          companyimg: JSON.parse(d.companyimg || '[]'), filelist: (JSON.parse(d.companyimg || '[]')).map((u) => ({ url: u }))
        }
      })
    }
  },
  created() {
    this.getuser()
  }
}
</script>
